const sortable = require('../../utils/dragAndDropSort');

export function initConfig() {
  sortable.create(document.getElementById('dash-tags'), { draggable: 'li' });
}

/*

  LEGACY ADMIN

*/

const sum = require('lodash/sumBy');
const { select } = require('d3-selection');

export function init() {
  $('#survey_id').change(changeSurvey);
  var drawDashChart = function() {
    if (typeof d3 === 'undefined' || d3 === null) {
      return ICMIB.delay(1000, drawDashChart);
    }
    horizontalPercentageBar('#dsh_srv_cht', ICMIB.dsh_srv_cht);
    return horizontalPercentageBar(
      '#community_health_chart',
      ICMIB.community_health_data
    );
  };
  return drawDashChart();
}

function horizontalPercentageBar(elem, data) {
  if (typeof d3 === 'undefined' || d3 === null) {
    const redraw = () => horizontalPercentageBar(elem, data);
    return setTimeout(redraw, 300);
  }

  const chart = select(elem);

  const chart_data = data[0];
  const total = chart_data.total || sum(chart_data.values, d => d.value);
  const data_points = chart_data.values.sort((a, b) => a.choice - b.choice);

  const bar = chart.append('div').attr('class', 'srv-com-cht__bar');

  bar
    .selectAll('.srv-com-cht__bar__seg')
    .data(data_points)
    .enter()
    .append('span')
    .attr('class', d =>
      ['srv-com-cht__bar__seg', d.choice, d.barClass].join(' ')
    )
    .attr('style', function(d) {
      const width = d.width
        ? d.width
        : d.value === 0
        ? 0
        : Math.min((d.value / total) * 100, 100) + '%';
      return `width: ${width};`;
    });

  const legend = chart.append('div').classed('srv-com-cht__legend', true);

  return legend
    .selectAll('srv-com-cht__legend__seg')
    .data(data_points)
    .enter()
    .append('span')
    .attr('class', d =>
      ['srv-com-cht__legend__seg', d.choice, d.textClass].join(' ')
    )
    .html(function(d) {
      if (d.text) {
        return d.text;
      } else {
        return d.value + ' ' + d.choice;
      }
    });
}

function changeSurvey() {
  const $this = $(this);
  return $.ajax({
    url: $this.find(':selected').data('url'),
    type: 'post',
    data: {
      id: $this.val(),
    },
    beforeSend() {},
    complete() {},
    success: changeSurveySuccess,
    error() {},
  });
}

function changeSurveySuccess(data) {
  $('#dsh_srv_cht').empty();
  $('.dsh_srv_cnt em').text(data[0].invited);
  return horizontalPercentageBar('#dsh_srv_cht', data);
}
